import { FETCH_USER } from 'src/common/actions/users';

import createMappedReducer from './utils/createMappedReducer';
import createRequestLifecycleHandlers from './utils/createRequestLifecycleHandlers';
import createContainerNavigationHandlers from './utils/createContainerNavigationHandlers';

export const users = createMappedReducer(
  {},
  {
    ...createContainerNavigationHandlers(),
    ...createRequestLifecycleHandlers({ fetchActionNameRoot: FETCH_USER }),
  },
);
